import { hasOwnProperty, safeIdCompare } from './utils';
import { Translated, ContentTemplateTranslation } from '../../shared/types/translation';
import {
  BareContentTemplate,
  BareContentTemplateLegacy,
  BasicContentTemplate,
} from '../../shared/types/contentTemplate';
import { Property } from '../../shared/types/property';

export function translateBareContentTemplate(
  contentTemplate: BareContentTemplate,
  translation?: ContentTemplateTranslation,
  lang?: string
): Translated<BareContentTemplate> | undefined {
  if (!translation || !lang) return undefined;
  const { transforms: transforms } = translation;

  if (!transforms || !hasOwnProperty(transforms, lang) || !transforms[lang].active) {
    return undefined;
  }

  return {
    ...contentTemplate,
    content: transforms[lang].delta.content,
    ...(isNotBasicContentTemplate(contentTemplate)
      ? { name: transforms[lang].delta.name, description: transforms[lang].delta.description }
      : {}),
    _lang: lang,
  };
}

export function convertContentTemplateToLegacy(
  contentTemplate: BareContentTemplate,
  property: Property
): BareContentTemplateLegacy {
  const { source: _, brand: __, properties: ___, ...rest } = contentTemplate;

  return {
    ...rest,
    property: property._id,
  };
}

export function convertLegacyContentTemplateToReal(
  contentTemplates: BareContentTemplate[],
  legacy: BareContentTemplateLegacy
): BareContentTemplate | undefined {
  const result = contentTemplates.find(ct => safeIdCompare(ct._id, legacy._id));
  return result;
}

export function isNotBasicContentTemplate(
  contentTemplate: BareContentTemplate
): contentTemplate is Exclude<BareContentTemplate, BasicContentTemplate> {
  return contentTemplate.type !== 'basic' && contentTemplate.type !== undefined;
}
